export default "__VITE_ASSET__Df$zZre$__"